import React from "react";

import GvAvatarCustom from "../../../../components/GvAvatarCustom/GvAvatarCustom";
import { IPetItemResponse } from "../../../../services/Standard-of-care/standard-of-care.interface";
import { LIST_GENDERS } from "../../../../config/params";

const getSexLabel = (
  gender: string | undefined,
  isDesexed: boolean | null,
): string | undefined => {
  const match = LIST_GENDERS.find((item) => item.value === gender);
  const base =
    match?.label ??
    (gender === "2" ? "Male" : gender === "4" ? "Female" : undefined);

  if (!base) {
    return undefined;
  }

  if (isDesexed) {
    return base === "Female" ? "Spayed female" : "Neutered male";
  }

  return base;
};

type Props = {
  petData: IPetItemResponse;
};

const PetHeaderCard = (props: Props) => {
  const { petData } = props;

  const subtitle = [
    petData.breedName || petData.breed,
    getSexLabel(petData.gender, petData.isDesexed),
    petData.age,
  ]
    .filter((part) => part !== null && part !== undefined && part !== "")
    .join(" · ");

  return (
    <div className="flex items-center gap-3 min-h-[5.5rem] p-3 rounded-xl border border-taupe-50 bg-white">
      <GvAvatarCustom
        image={petData.image}
        name={petData.name}
        width={56}
        height={56}
        className="border-2 border-white rounded-full shrink-0"
      />
      <div className="flex flex-col gap-2 min-w-0">
        <p className="grenette-pro text-[18px] leading-[16px] font-semibold text-light-black truncate">
          {petData.name}
        </p>
        {subtitle && (
          <p className="geograph-regular text-[12px] leading-[18px] text-gray-1 truncate">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PetHeaderCard;
